import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import {
    CALL_PPOR_API,
    MIDDLE_WARE_BASE_URL_v1,
} from "../../../utils/CONSTANTS";
 
const initialState = {
    getBannerDataState: '',
    getData: '',
};
export const getBannerData = createAsyncThunk(
    "get/getBannerData",
    async (data: any) => {
        const response = axios.postStringRequest(
            MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
            data
        );
        return response;
    }
);
 
const getBannerDataSlice = createSlice({
    name: "getBannerData",
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(getBannerData.pending, (state) => {
                state.getBannerDataState = "pending";
            })
            .addCase(getBannerData.fulfilled, (state, action) => {
                let tempRes = action.payload.data?.response;
                if (typeof tempRes === "string") {
                    tempRes = JSON.parse(tempRes);
                    console.log(tempRes);
                }
                state.getBannerDataState = "fulfilled";
                state.getData = tempRes?.response?.banner;
                //console.log("getBannersData", state.getData);
            })
            .addCase(getBannerData.rejected, (state) => {
                state.getBannerDataState = "failed";
            })
});
 
export const selectBannerData = (state: any) => state.getBannerData || {};
 
export default getBannerDataSlice.reducer;